import React from "react";

import "./EditChartIcons.scss";

const EditTags = props => {
  const getClassName = () => {
    const styleClass = "chart-edit-icon";
    return props.active ? `${styleClass}-active` : styleClass;
  };

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33 33" className={getClassName()}>
      <g id="Edit_Tags" data-name="Edit_Tags" transform="translate(0.5 0.5)">
        <g id="Group_15139" data-name="Group 15139">
          <path id="margin" fill="#fff" stroke="#707070" opacity="0" d="M0 0H32V32H0Z" />
          <path
            id="Path_8960"
            data-name="Path 8960"
            className="icon-stroke icon-background"
            strokeMiterlimit="10"
            d="M7.755 4.5H18.28a.764.764 0 0 1 .755.772V19.878l-6.018-2.461L7 19.878V5.272A.763.763 0 0 1 7.755 4.5Z"
            transform="translate(2.982 3.689)"
          />
          <path id="gap" fill="none" d="M9.055 18.03V12.77L18.845 3l5.24 5.261-9.79 9.77Z" transform="translate(1.519 2.342)" />
          <path
            id="Path_13509"
            data-name="Path 13509"
            className="icon-fill"
            d="M19.909,11.4 18.028,9.515l-5.266 5.266L12 17.424l2.643-.761Z"
            transform="translate(0.793 0.366)"
          />
          <path
            id="Rectangle_4094"
            data-name="Rectangle 4094"
            className="icon-fill"
            d="M1 0h.661a1 1 0 0 1 1 1V2.661a0 0 0 0 1 0 0H0a0 0 0 0 1 0 0V1A1 1 0 0 1 1 0Z"
            transform="translate(20.702 8) rotate(45)"
          />
        </g>
      </g>
    </svg>
  );
};

export default EditTags;
